<template>
  <el-tabs
    type="border-card"
    :before-leave="beforeLeaveM"
    v-model="activeTab"
    v-loading="loading"
  >
    <el-tab-pane
      v-for="(tab, index) in defaultTab"
      :key="index"
      :label="tab.label"
      :name="tab.name"
    >
      <rabbey-table2
        :key="index"
        :ref="`table_${tab.name}`"
        :columns="tab.columns !== undefined ? tab.columns : columns"
        :actions="tab.actions !== undefined ? tab.actions : actions"
        :default-params="getParams(activeTab)"
        :search="search"
        :key-search="tab.keySearch !== undefined ? tab.keySearch : keySearch"
        @rtable-push-action="handleCommand"
      >
        <slot name="actions"></slot>
      </rabbey-table2>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
import { PAGINATION_DEFAULT } from "@/const";

export default {
  name: "RabbeyTablesTabs2",
  props: {
    /**
     * Tab active by default.
     */
    defaultTabActive: {
      type: String,
      required: false
    },
    keySearch: {
      type: String,
      required: false,
      default: "Name"
    },
    /**
     * API url for querying table data.
     *
     * This is used in the table component.
     */
    indexUrl: {
      type: String,
      required: true
    },
    tabUrl: {
      type: String,
      required: false
    },
    tabList: {
      type: Array,
      required: false
    },
    columns: {
      type: Array,
      required: false
    },
    actions: {
      type: Array,
      required: false
    },
    keyTab: {
      type: String,
      required: true
    },
    getParams: {
      type: Function,
      required: false
    }
  },
  data() {
    return { activeTab: "", defaultTab: [], search: "" };
  },
  created() {
    this.setUrl(this.indexUrl);

    if (this.tabUrl !== undefined) {
      this.getTabs({ url: this.tabUrl });
      this.defaultTab = this.tabs;
    } else {
      this.defaultTab = this.tabList;
    }

    if (this.defaultTabActive !== undefined) {
      this.activeTab = this.defaultTabActive;
    } else {
      if (this.tabs !== undefined && this.tabs.length > 0) {
        this.activeTab = this.tabs[0].name;
      }
    }

    this.getItems({ params: this.getParams(this.activeTab) });
  },
  methods: {
    ...mapMutations({
      setUrl: "rabbey_table/url",
      setPagination: "rabbey_table/pagination"
    }),
    ...mapActions({
      getTabs: "rabbey_tabs/getTabs",
      getItems: "rabbey_table/getItems"
    }),
    /**
     * Captura el evento click en las acciones de la tabla
     * y luego emite este evento al padre de este componente.
     */
    handleCommand(command) {
      this.$emit("table-push-action", command);
    },
    beforeLeaveM(a, o) {
      // Es necesario resetear el pagination para el nuevo tab.
      this.setPagination(PAGINATION_DEFAULT);
      this.$emit("tab-change", a, o);
      this.getItems({ params: this.getParams(a) });
    },
    rabbeyTable() {
      const table = this.$refs[`table_${this.activeTab}`];
      return table !== undefined ? table[0] : undefined;
    }
  },
  computed: {
    ...mapState({
      tabs: (state) => state.rabbey_tabs.tabs,
      loading: (state) => state.rabbey_tabs.status === "loading"
    })
  }
};
</script>

<style></style>
